/* eslint-disable import/prefer-default-export */
import { configureStore } from '@reduxjs/toolkit';
import { rootReducer as reducer } from 'rcm-binder';

export const store = configureStore({
  reducer
});
